import { CDFISortingData, CdfiStatsNameEnum, FiscalYearRangeEnum } from '@/types';

export * from './queryKeys';
export * from './breadcrumbs';
export * from './apiBaseUrls';
export * from './apiRoutes';
export * from './providers';
export * from './storageKeys';

export const osType = {
  win: 'Windows',
  mac: 'Mac',
};
export const LEAGUE_KEY = 512;
export const DEFAULT_TOAST_ERROR_TITLE = 'Something went wrong';
export const DEFAULT_TOAST_ERROR_MESSAGE =
  'Please, try again. If the error persists, call your Account Management representative.';
export const CDFI_CERTIFICATION_ALERT_TEXT =
  "Please note, the analysis on this dashboard is based on the loans in your most recently uploaded AIRES loan file, which may not reflect all loans originated and purchased in your most recently completed fiscal year, which will be the basis of the CDFI Fund's assessment. To gain a complete picture of where your credit union stands against the CDFI Fund's Target Market lending requirements, please reach out to your Account Manager.";
export const DATA_MANAGEMENT_API_TOOLTIP =
  "CUCollaborate's IRL API allows users to develop standalone applications that enrich potential or existing members data.";
export const DATA_PREPARER_UPLOAD_TOOLTIP =
  "Data Preparer is a desktop application which will secure your members' data by removing sensitive information such as Social Security number, account number and Names from AIRES files";
export const DATA_PREPARER_UPLOAD_DATE =
  'Document Date is the date that the data within a file refers to, e.g., if an AIRES file lists loan (or share) accounts as of December 31, 2021, its document date would be 12/31/2021.';
export const REQUIRED_FIELD = 'This field is required';
export const OLD_DATA_PREPARER_VERSION_RESPONSE =
  'The file(s) was prepared with an outdated version of the Data Preparer. Please download the new version of the app, prepare the files and upload them.';

export const CDFI_CATEGORIES = {
  CIA: { display: 'Custom Investment Area (CIA)', server: 'CIA' },
  IA: { display: 'Investment Area (IA)', server: 'IA' },
  LITP: { display: 'Low-income Target Population (LITP)', server: 'LITP' },
  OTP: { display: 'Other Targeted Population (OTP)', server: 'OTP' },
  AfricanAmerican: {
    display: 'African American (OTP)',
    server: 'African American',
  },
  Hispanic: { display: 'Hispanic (OTP)', server: 'Hispanic' },
  NativeAmerican: {
    display: 'Native American (OTP)',
    server: 'Native American',
  },
  NativeAlaskan: { display: 'Native Alaskan (OTP)', server: 'Native Alaskan' },
  NativeHawaiian: {
    display: 'Native Hawaiian (OTP)',
    server: 'Native Hawaiian',
  },
  OtherPacificIslander: {
    display: 'Other Pacific Islander (OTP)',
    server: 'Other Pacific Islander',
  },
  Filipino: { display: 'Filipino (OTP)', server: 'Filipino' },
  Vietnamese: { display: 'Vietnamese (OTP)', server: 'Vietnamese' },
  PersonsWithDisabilities: {
    display: 'Persons with Disabilities (OTP)',
    server: 'Persons with Disabilities',
  },
  CertifiedCDFIs: {
    display: 'Certified CDFIs (OTP)',
    server: 'Certified CDFIs',
  },
};

export const CDFI_LS_CATEGORIES_KEY = 'cdfi_categories';
export const CDFI_LS_SORTING_KEY = 'cdfi_sorting';

export const cdfiStatsLabelMap = {
  [CdfiStatsNameEnum.LOAN]: 'CDFI Target Market Loans (by Number of Loans)',
  [CdfiStatsNameEnum.DOLLAR]: 'CDFI Target Market Loans (by Dollar Amount)',
  [CdfiStatsNameEnum.ACCOUNT_HOLDERS]: 'Number of Unique Depository Account Holders',
};

export const cdfiStatsPrimaryMetricLabelMap = {
  [CdfiStatsNameEnum.LOAN]: 'Total Number of Loans',
  [CdfiStatsNameEnum.DOLLAR]: 'Total Dollar Amount of Loans',
  [CdfiStatsNameEnum.ACCOUNT_HOLDERS]: 'Total members',
};

export const cdfiStatsSecondaryMetricLabelMap = {
  [CdfiStatsNameEnum.LOAN]: 'Number of CDFI Target Market loans',
  [CdfiStatsNameEnum.DOLLAR]: 'Dollar amount of CDFI Target Market loans',
  [CdfiStatsNameEnum.ACCOUNT_HOLDERS]: 'CDFI qualified members',
};

export const cdfiStatsHeaderMap = {
  [CdfiStatsNameEnum.LOAN]: ['Category', 'TM Loan', '# of Loans', 'Percentage'],
  [CdfiStatsNameEnum.DOLLAR]: ['Category', 'TM Loan', 'Dollar amount', 'Percentage'],
  [CdfiStatsNameEnum.ACCOUNT_HOLDERS]: ['Category', 'TM Loan', '# of Members', 'Percentage'],
};

export const subLabelMap = {
  [CdfiStatsNameEnum.LOAN]: '(at least 60% needed to qualify)',
  [CdfiStatsNameEnum.DOLLAR]: '(at least 50% needed for the Financial Service option)',
  [CdfiStatsNameEnum.ACCOUNT_HOLDERS]: '(at least 60% needed to qualify)',
};

export const cdfiSortingPeriod = {
  [FiscalYearRangeEnum.CurrentYear]: 'Current Fiscal Year',
  [FiscalYearRangeEnum.MostRecentCompleteFiscalYear]: 'Most Recent Complete Fiscal Year',
  [FiscalYearRangeEnum.TwoCompleteFiscalYears]: 'Two Complete Fiscal Years',
  [FiscalYearRangeEnum.ThreeCompleteFiscalYears]: 'Three Complete Fiscal Years',
};

export const cdfiCategoryServerToDisplayMap = Object.values(CDFI_CATEGORIES).reduce(
  (acc, { display, server }) => {
    acc[server] = display;
    return acc;
  },
  {} as Record<string, string>,
);

export const DEFAULT_SORTING_DATA: CDFISortingData = {
  fiscalYearEnd: new Date().toISOString(),
  period: FiscalYearRangeEnum.MostRecentCompleteFiscalYear,
};

export const DEFAULT_CDFI_CATEGORIES = [
  CDFI_CATEGORIES.CIA.display,
  CDFI_CATEGORIES.IA.display,
  CDFI_CATEGORIES.LITP.display,
];

export const cdfiMapCategories = Object.values(CDFI_CATEGORIES).reduce(
  (acc, { display, server }) => {
    acc[display] = server;
    return acc;
  },
  {} as Record<string, string>,
);
